import { useEffect, useState } from 'react';

const NARROW_VIEWPORT_QUERY = '(max-width: 60rem)';

export const useIsNarrowViewport = () => {
  const [isNarrowViewport, setIsNarrowViewport] = useState(
    () => window.matchMedia(NARROW_VIEWPORT_QUERY).matches
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia(NARROW_VIEWPORT_QUERY);

    const syncFromMediaQuery = () => setIsNarrowViewport(mediaQuery.matches);

    mediaQuery.addEventListener('change', syncFromMediaQuery);

    const rootObserver = new ResizeObserver(syncFromMediaQuery);

    rootObserver.observe(document.documentElement);

    return () => {
      mediaQuery.removeEventListener('change', syncFromMediaQuery);
      rootObserver.disconnect();
    };
  }, []);

  return isNarrowViewport;
};
